import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class LEDTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "featureColumn", title: "IR Spotlight Model" },
        { name: "valueColumn", title: "INSTAR IN-903" }
      ],
      rows: [
        { featureColumn: 'Available Colours', valueColumn: 'Black / White' },
        { featureColumn: 'Illumination Angle', valueColumn: '80 °' },
        { featureColumn: 'Range', valueColumn: '15 - 20 m' },
        { featureColumn: 'Number of LEDs', valueColumn: '60 GaAlAs LEDs' },
        { featureColumn: 'Wavelength', valueColumn: '850 nm' },
        { featureColumn: 'Output /LED', valueColumn: '0.1 Watt' },
        { featureColumn: 'Power Supply', valueColumn: '110 V - 220 V (50 Hz - 60 Hz)' },
        { featureColumn: 'Power Consumption', valueColumn: '8 Watt (max.)' },
        { featureColumn: 'Weight', valueColumn: '300 g' },
        { featureColumn: 'Measurements H/W/D', valueColumn: '11.4 cm / 12.9 cm / 10.3 cm' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

LEDTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(LEDTable)